// Material UI Custom Typography: https://material-ui.com/customization/typography/
module.exports = {
  fontFamily: "'Ubuntu', Arial, sans-serif",
};
